export default "__VITE_ASSET__e5fb7504__"